module.exports = __webpack_public_path__ + "static/img/20.b647751.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/20.png
// module id = b3DP
// module chunks = 0